import type { CapturedWeight } from "~/stores/kiosk-session/types";
import { formatWeightReading } from "~/utils/weight-units";

type WeightPreviewProps = {
  weight: CapturedWeight;
};

export const WeightPreview = ({ weight }: WeightPreviewProps) => {
  return (
    <div className="flex h-24 items-center justify-center rounded-lg bg-kiosk-background-secondary text-center text-3xl font-bold">
      <p className="whitespace-nowrap px-6">{formatWeightReading(weight)}</p>
    </div>
  );
};
